import Section from 'app/frontend/base/components/Section'
import { useTeam } from 'app/frontend/base/config/context/team'

const TeamOverview = () => {
  const { team, guild } = useTeam()

  return (
    <Section title={`${team.name} | ${guild.name}`}>
      TeamOverview! {team.id}
    </Section>
  )
}

export default TeamOverview
